import { Product } from '../';

export function IsProductWithSameName(name?: string) {
  return function(product: Product): product is Product {
    return name === product.name;
  }
}
